import type { Avaliation, WorkoutPlan } from "../../../types";

/**
 * Funções utilitárias para o componente StudentManagementModal
 */

export const safeNumber = (value: string | number | undefined) => {
  if (value === undefined || value === null) return 0;
  if (typeof value === "number") return value;
  const cleanValue = String(value).replace(",", ".");
  const num = Number(cleanValue);
  return isNaN(num) ? 0 : num;
};

export const formatNumber = (
  value: string | number | undefined,
  decimals = 1,
) => {
  if (value === undefined || value === null || value === "") return "-";
  const num = safeNumber(value);
  if (!num || Number.isNaN(num)) return "-";
  return num.toFixed(decimals).replace(".", ",");
};

export function getAvaliationTimestamp(avaliation: Avaliation): number {
  const value = avaliation.date || avaliation.registe || "";
  if (!value) return 0;
  const time = new Date(value).getTime();
  if (Number.isNaN(time)) return 0;
  return time;
}

export function getWorkoutTimestamp(plan: WorkoutPlan): number {
  const value = plan.created_at || plan.start_date || "";
  if (!value) return 0;
  const time = new Date(value).getTime();
  if (Number.isNaN(time)) return 0;
  return time;
}
